import {
  createLocalDeliveryOption as publicCreateLocalDeliveryOption,
  getLocalDeliveryOption as publicGetLocalDeliveryOption,
  listLocalDeliveryOptions as publicListLocalDeliveryOptions,
  queryLocalDeliveryOptions as publicQueryLocalDeliveryOptions,
  updateLocalDeliveryOption as publicUpdateLocalDeliveryOption,
  deleteLocalDeliveryOption as publicDeleteLocalDeliveryOption,
  bulkCreateLocalDeliveryOption as publicBulkCreateLocalDeliveryOption,
  bulkUpdateLocalDeliveryOption as publicBulkUpdateLocalDeliveryOption,
  bulkDeleteLocalDeliveryOption as publicBulkDeleteLocalDeliveryOption,
  addDeliveryRegion as publicAddDeliveryRegion,
  removeDeliveryRegion as publicRemoveDeliveryRegion,
} from './ecom-v1-local-delivery-option-local-delivery-options.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createLocalDeliveryOption: MaybeContext<
  BuildRESTFunction<typeof publicCreateLocalDeliveryOption> &
    typeof publicCreateLocalDeliveryOption
> = /*#__PURE__*/ createRESTModule(publicCreateLocalDeliveryOption);
export const getLocalDeliveryOption: MaybeContext<
  BuildRESTFunction<typeof publicGetLocalDeliveryOption> &
    typeof publicGetLocalDeliveryOption
> = /*#__PURE__*/ createRESTModule(publicGetLocalDeliveryOption);
export const listLocalDeliveryOptions: MaybeContext<
  BuildRESTFunction<typeof publicListLocalDeliveryOptions> &
    typeof publicListLocalDeliveryOptions
> = /*#__PURE__*/ createRESTModule(publicListLocalDeliveryOptions);
export const queryLocalDeliveryOptions: MaybeContext<
  BuildRESTFunction<typeof publicQueryLocalDeliveryOptions> &
    typeof publicQueryLocalDeliveryOptions
> = /*#__PURE__*/ createRESTModule(publicQueryLocalDeliveryOptions);
export const updateLocalDeliveryOption: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLocalDeliveryOption> &
    typeof publicUpdateLocalDeliveryOption
> = /*#__PURE__*/ createRESTModule(publicUpdateLocalDeliveryOption);
export const deleteLocalDeliveryOption: MaybeContext<
  BuildRESTFunction<typeof publicDeleteLocalDeliveryOption> &
    typeof publicDeleteLocalDeliveryOption
> = /*#__PURE__*/ createRESTModule(publicDeleteLocalDeliveryOption);
export const bulkCreateLocalDeliveryOption: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateLocalDeliveryOption> &
    typeof publicBulkCreateLocalDeliveryOption
> = /*#__PURE__*/ createRESTModule(publicBulkCreateLocalDeliveryOption);
export const bulkUpdateLocalDeliveryOption: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateLocalDeliveryOption> &
    typeof publicBulkUpdateLocalDeliveryOption
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateLocalDeliveryOption);
export const bulkDeleteLocalDeliveryOption: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteLocalDeliveryOption> &
    typeof publicBulkDeleteLocalDeliveryOption
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteLocalDeliveryOption);
export const addDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicAddDeliveryRegion> &
    typeof publicAddDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicAddDeliveryRegion);
export const removeDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicRemoveDeliveryRegion> &
    typeof publicRemoveDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicRemoveDeliveryRegion);

export {
  LengthUnit,
  DayOfWeek,
  ConditionType,
  LogicalOperator,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';
export {
  LocalDeliveryOption,
  LocalDeliveryOptionConfigOneOf,
  Destination,
  ZipCodeConfig,
  RadiusConfig,
  LocalDeliveryAddress,
  AddressLocation,
  CustomAreaConfig,
  ScheduledDelivery,
  Days,
  DaySlot,
  TimeSlot,
  TimePoint,
  TimeWindow,
  TimeOfDay,
  ConditionalRates,
  Condition,
  CreateLocalDeliveryOptionRequest,
  CreateLocalDeliveryOptionResponse,
  GetLocalDeliveryOptionRequest,
  GetLocalDeliveryOptionResponse,
  ListLocalDeliveryOptionsRequest,
  ListLocalDeliveryOptionsResponse,
  QueryLocalDeliveryOptionsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryLocalDeliveryOptionsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateLocalDeliveryOptionRequest,
  UpdateLocalDeliveryOptionResponse,
  DeleteLocalDeliveryOptionRequest,
  DeleteLocalDeliveryOptionResponse,
  BulkCreateLocalDeliveryOptionRequest,
  BulkCreateLocalDeliveryOptionResponse,
  LocalDeliveryOptionError,
  BulkUpdateLocalDeliveryOptionRequest,
  BulkUpdateLocalDeliveryOptionResponse,
  BulkDeleteLocalDeliveryOptionRequest,
  BulkDeleteLocalDeliveryOptionResponse,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  AddDeliveryRegionRequest,
  AddDeliveryRegionResponse,
  RemoveDeliveryRegionRequest,
  RemoveDeliveryRegionResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  LocalDeliveryOptionNonNullableFields,
  CreateLocalDeliveryOptionResponseNonNullableFields,
  GetLocalDeliveryOptionResponseNonNullableFields,
  ListLocalDeliveryOptionsResponseNonNullableFields,
  QueryLocalDeliveryOptionsResponseNonNullableFields,
  UpdateLocalDeliveryOptionResponseNonNullableFields,
  BulkCreateLocalDeliveryOptionResponseNonNullableFields,
  BulkUpdateLocalDeliveryOptionResponseNonNullableFields,
  AddDeliveryRegionResponseNonNullableFields,
  RemoveDeliveryRegionResponseNonNullableFields,
  GetLocalDeliveryOptionOptions,
  LocalDeliveryOptionsQueryResult,
  LocalDeliveryOptionsQueryBuilder,
  UpdateLocalDeliveryOption,
  DeleteLocalDeliveryOptionOptions,
  AddDeliveryRegionOptions,
  RemoveDeliveryRegionOptions,
} from './ecom-v1-local-delivery-option-local-delivery-options.universal.js';
